import React, { useContext, useEffect, useState } from 'react'
import { MainLanguageContext } from '../../context/MainLanguageContext';
import useGet from '../../customHooks/useGet';
import usePost from '../../customHooks/usePost';
import { toast } from 'react-toastify';
import swal from "sweetalert";
import { Form, Formik } from 'formik';
import FormControl from '../../components/form/FormControl';
import SubmitButton from '../../components/SubmitButton';
import SkeletonPromotions from './SkeletonPromotions';
import CKEditors from '../../components/form/CKEditors';
import OneImageUpload from '../../components/OneImageUpload';

const WebPromotions = () => {
       const [imageLoader, setImageLoader] = useState(false)
    const { mainLanguage } = useContext(MainLanguageContext);
    const [datas, setDatas] = useState(
        {
            "banner": "",
            "promotion_paragraph": ""
        }
    )
    const [resget, apiMethodGet] = useGet()
    useEffect(() => {
        if (mainLanguage) {
            apiMethodGet(`webContents/metadata/promotions/${mainLanguage}`);
        }
    }, [mainLanguage]);

    useEffect(() => {
        if (!resget.isLoading) {
            setDatas(resget?.data?.data)
        }
    }, [resget.data])


      const handleCkChange = (e, type) => {
        setDatas(d => ({ ...d, [type]: e }));
      };

    

    const [res, apiMethod] = usePost()
    const requireFeild = ["meta_title", "meta_description", "banner_title"];

    const handleSubmit = (values) => {
        if (imageLoader) {
            swal({
                title: "Wait a Few Second",
                icon: "error",
                dangerMode: true,
            });
        }
        else {
        let formdata = new FormData();
        let requireFeildSwal = {
            meta_title: "Meta Title",
            meta_description: "Meta Description",
            banner_title: "banner_title",
        };
        let checkerRequried = [];
        for (const item in values) {
            if (requireFeild.includes(item) && values[item] === "") {
                checkerRequried.push(requireFeildSwal[item]);
            }
            formdata.append(`translation[${item}]`, values[item] ?? "");
        }


        if (checkerRequried.length > 0) {
            swal({
                title: "Required Fields are empty! Please fill and try again",
                text: checkerRequried.join(","),
                icon: "error",
                dangerMode: true,
            });
        }

        else {
            formdata.append(`translation[promotion_paragraph]`, datas?.promotion_paragraph ?? "");
            formdata.append(`banner`, datas?.banner_value ?? "");
            apiMethod(`webContents/metadata/promotions/${mainLanguage}`, formdata)
        }
    }
    }

    useEffect(() => {
        if (res.data) {
            const { status, message } = res?.data
            if (status === "false") {
                toast.error(message);
            }
            else {
                toast.success(message);
            }
        }
    }, [res.data])


    if (resget.isLoading || !resget.data) return <SkeletonPromotions />
    const initialValues = {
        meta_title: resget?.data?.data?.meta_title ?? "",
        meta_description: resget?.data?.data?.meta_description ?? "",
        banner_title: resget?.data?.data?.banner_title ?? "",
    }

    return (
        <section className='promotions'>
            <Formik initialValues={initialValues} onSubmit={handleSubmit}  >
                <Form>
                    <div className='bg-[#A38560]/10 p-6 rounded-3xl mb-8'>
                        <FormControl name="meta_title" label={"Meta Title"} placeholder="Enter Meta Title" className="outline-none w-full h-[2.3rem] px-[0.65rem] rounded-[5px]" control="input2" />
                            <FormControl name="meta_description" label={"Meta Description"} placeholder="Enter Meta Description" className="outline-none w-full h-[10rem] px-5 py-3 rounded-xl resize-none" control="textarea2" />
                  
                    </div>

                    <div className='bg-[#A38560]/10 p-6 rounded-3xl mb-8'>
                        <FormControl name="banner_title" label={"banner Title"} placeholder="Enter banner Title" className="outline-none w-full h-[2.3rem] px-[0.65rem] rounded-[5px]" control="input2" />
                        <br />
                        <div className="mb-1 block text-secondary text-[.8rem]">Promotions Details</div>
                        <CKEditors label={"Promotions Details"} data={datas?.promotion_paragraph} update={(text) => handleCkChange(text, "promotion_paragraph")} />            
            <div className='mt-4'>
              <div>
                <label className="mb-1  mt-3 blocktext-secondary text-[.8rem]">Banner Image </label>
                <OneImageUpload changeImage={setImageLoader} MainImage={datas?.banner} Update={setDatas} sec_value={"banner_value"} sec_image={"banner"} folder_name={"web_content_images"} page_type={"Promotions"} />
              </div>
            </div>
                    </div>
                  

                    {(
                        <SubmitButton
                            props={{
                                class: "btn bg-secondary text-white uppercase py-3 px-10 rounded-full w-fit block submit hover:bg-primary transition-all duration-300",
                                text: "Update",
                            }}
                            buttonLoading={res.isLoading}
                        />
                    )}
                    <br />
                </Form>
            </Formik>
        </section>
    )
}

export default WebPromotions